module.exports = __webpack_public_path__ + "img/HomeBtn.9495d2ca.svg";